<template>
  <div style="padding: 10px; width: 100%">
    <div class="row">
      <div
        v-bind:class="{
          'col-6': this.isWorkSlipEmployee,
          'col-12': !this.isWorkSlipEmployee,
        }"
      >
        <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
        <div class="div-field">
          <datetime
            v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
            v-model="selectedStartTime"
            v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
            input-style="text-align:center"
            class="theme-blue"
            v-bind:backdrop-click="false"
            :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
            :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
          >
          </datetime>
        </div>
      </div>
      <div class="col-6" v-if="this.isWorkSlipEmployee">
        <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
        <div class="div-field">
          <datetime
            v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
            v-model="selectedEndTime"
            v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
            input-style="text-align:center"
            class="theme-blue"
            v-bind:backdrop-click="false"
            :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
            :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
          >
          </datetime>
        </div>
      </div>
    </div>
    <div class="div-field" v-if="workSlips">
      <Dropdown
        v-model="selectedWorkSlip"
        :options="workSlips"
        optionLabel="name"
        :filter="true"
        :showClear="true"
        :placeholder="$t('WorkRegistrationForm.SelectWorkSlip')"
        @change="onSelectWorkSlip()"
      >
        <template #option="slotProps">
          <div>
            {{ slotProps.option.name }}
          </div>
        </template>
      </Dropdown>
    </div>
    <div class="div-field" v-if="activities">
      <Dropdown
        v-if="isWorkSlipEmployee"
        v-model="selectedActivity"
        :options="filteredActivities"
        optionLabel="name"
        :filter="true"
        :showClear="true"
        :placeholder="$t('WorkRegistrationForm.SelectActivity')"
        @change="onSelectActivity()"
      >
        <template #option="slotProps">
          <div
            v-bind:class="{
              recent: slotProps.option.isRecent,
            }"
          >
            {{ slotProps.option.name }}
          </div>
        </template>
      </Dropdown>
      <Dropdown
        v-else
        v-model="selectedActivity"
        :options="activities"
        optionLabel="name"
        :filter="true"
        :showClear="true"
        :placeholder="$t('WorkRegistrationForm.SelectActivity')"
        @change="onSelectActivity()"
      >
        <template #option="slotProps">
          <div
            v-bind:class="{
              recent: slotProps.option.isRecent,
            }"
          >
            {{ slotProps.option.name }}
          </div>
        </template>
      </Dropdown>
    </div>
    <div class="div-field" v-if="projects">
      <Dropdown
        v-model="selectedProject"
        :options="projects"
        optionLabel="name"
        :filter="true"
        :showClear="true"
        :placeholder="$t('WorkRegistrationForm.SelectProject')"
        @change="onSelectProject()"
        :disabled="!!selectedWorkSlip"
      >
        <template #option="slotProps">
          <div
            v-bind:class="{
              recent: slotProps.option.isRecent,
            }"
          >
            {{ slotProps.option.name }}
          </div>
        </template>
      </Dropdown>
    </div>
    <div class="div-field" v-if="selectedActivity">
      <div
        v-if="selectedActivity.remarks && selectedActivity.remarks.length > 0"
      >
        <Listbox
          v-model="selectedRemarks"
          :options="remarks"
          :multiple="true"
          optionLabel="name"
        />
      </div>
      <div class="div-field">
        <Textarea v-model="remark" :autoResize="true" rows="5" cols="30" />
      </div>
      <div class="div-field">
        <span
          v-if="selectedActivity.descriptionRequired && !remark"
          class="text-danger text-left"
        >
          <span>{{ $t("WorkRegistrationForm.CommentRequired") }}</span>
        </span>
      </div>
    </div>
    <div>
      <button
        v-if="
          selectedActivity && [182, 183, 224, 235].includes(selectedActivity.id)
        "
        class="custom-mobile-button"
        @click="showDriverModal = !showDriverModal"
      >
        {{ $t("DriverSelector.Driver") }}
        <!-- {{
                  selectedWorkRegistration.driver
                    ? selectedWorkRegistration.driver
                    : ""
                }} -->
      </button>
    </div>
    <div v-if="selectedActivity">
      <button
        :disabled="selectedActivity.descriptionRequired && !remark"
        class="custom-mobile-button"
        @click="checkIfWorkDayExists()"
      >
        {{ $t("WorkRegistrationForm.Save") }}
      </button>
    </div>
    <div>
      <BackButton />
    </div>
    <DriverSelector
      v-if="selectedActivity"
      :display="showDriverModal"
      :drivers="drivers"
      @confirmed="onSelectedDriver"
    />
    <WorkRegistrationEndTimeDialog
      :display="showEndTimeDialog"
      @confirmed="onSelectedEndTime"
    />
  </div>
</template>
<script>
import LocalStorageService from "../services/LocalStorageService";
import ProjectService from "../services/ProjectService";
import ActivityService from "../services/ActivityService";
import WorkRegistrationService from "../services/WorkRegistrationService";
import { formatDateTimeServer, formatDateServer } from "../utils";
import BackButton from "../components/common/BackButton";
import moment from "moment";
import WorkSlipService from "../services/WorkSlipService";
import DriverSelector from "../components/common/DriverSelector";
import WorkDayService from "../services/WorkDayService";
import WorkRegistrationEndTimeDialog from "../components/common/WorkRegistrationEndTimeDialog";

export default {
  name: "WorkRegistrationForm",
  components: { BackButton, DriverSelector, WorkRegistrationEndTimeDialog },
  props: {
    drivers: null,
    workRegistration: null,
    workDate: null,
    workDayEndTime: null,
  },
  workRegistrationService: null,
  activityService: null,
  projectService: null,
  localStorageService: null,
  workSlipService: null,
  workDayService: null,
  data() {
    return {
      showDriverModal: false,
      projects: null,
      selectedProject: null,
      activities: null,
      selectedActivity: null,
      remark: "",
      selectedTime: null,
      selectedRemarks: [],
      remarks: null,
      maxDatetime: null,
      minDatetime: null,
      workDayId: null,
      isWorkSlipEmployee: false,
      employee: null,
      workSlip: null,
      workSlips: null,
      maxWrEndTime: null,
      selectedWorkSlip: null,
      selectedStartTime: null,
      selectedEndTime: null,
      filteredActivities: null,
      showEndTimeDialog: false,
      workDay: null,
    };
  },
  created() {
    this.workRegistrationService = new WorkRegistrationService();
    this.activityService = new ActivityService();
    this.projectService = new ProjectService();
    this.localStorageService = new LocalStorageService();
    this.workSlipService = new WorkSlipService();
    this.workDayService = new WorkDayService();
    this.employee = this.localStorageService.getCurrentEmployee();
    this.isWorkSlipEmployee = this.employee.isWorkSlipEmployee;
    this.workDayId = this.$route.query.workDayId;
    this.getProjectInfos();
    this.getActivityInfos();
    this.getWorkRegistrationMaxEndTime();
  },
  mounted() {
    this.minDatetime = this.workDate;
    this.maxDatetime = moment(this.workDate)
      .add(1, "days")
      .add(23, "hours")
      .add(59, "minutes")
      .format("YYYY-MM-DD[T]HH:mm:00");
    this.getWorkDay();
  },
  methods: {
    onSelectedDriver(value) {
      this.showDriverModal = false;
      if (value && value.value === true) {
        const description = `Bestuurder: ${value.driver}`;
        this.remark = description;
      }
    },
    getWorkRegistrationMaxEndTime() {
      this.workRegistrationService
        .getWorkRegistrationMaxEndTime(this.workDayId, this.employee.id)
        .then((response) => {
          let self = this;
          self.maxWrEndTime = response.data;
          if (this.workRegistration) {
            this.selectedStartTime = formatDateTimeServer(
              new Date(this.workRegistration.startTime)
            );
            if (this.workRegistration.endTime != null) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workRegistration.endTime)
              );
            } else {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workDayEndTime)
              );
            }
          } else {
            const hours = new Date().getHours();
            const minutes = new Date().getMinutes();
            const startTime = new Date(this.workDate);
            startTime.setHours(hours);
            startTime.setMinutes(minutes);
            var end = null;
            if (self.maxWrEndTime) {
              this.selectedStartTime = formatDateTimeServer(self.maxWrEndTime);
              end = new Date(self.maxWrEndTime);
              end.setHours(end.getHours() + 1);
              this.selectedEndTime = formatDateTimeServer(end);
            } else {
              this.selectedStartTime = formatDateTimeServer(startTime);
              end = new Date(startTime);
              end.setHours(end.getHours() + 1);
              this.selectedEndTime = formatDateTimeServer(end);
            }
          }
          console.log(response.data);
        })
        .catch(() => {});
    },
    getWorkSlipOptions() {
      this.workSlipService
        .getWorkSlipOptions(this.workDate)
        .then((response) => {
          const result = response.data;
          if (result) {
            this.workSlips = result;
            if (this.workRegistration) {
              this.selectedWorkSlip = this.workSlips.find(
                (s) => s.value === this.workRegistration.workSlipNumber
              );
            }
          }
        })
        .catch(() => {});
    },
    getProjectInfos() {
      this.projectService
        .getProjectInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.projects = result.map((s) => {
              return {
                id: s.id,
                name: `${s.projectNumber} ${s.name}`,
                isRecent: s.isRecent,
              };
            });
            if (this.workRegistration) {
              this.selectedProject = this.projects.find(
                (s) => s.id === this.workRegistration.projectId
              );
            }
            if (this.isWorkSlipEmployee) this.getWorkSlipOptions();
          }
        })
        .catch(() => {});
    },
    onSelectProject() {
      this.selectedObject = null;
    },
    getActivityInfos() {
      this.activityService
        .getActivityInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.activities = result.map((s) => {
              return {
                id: s.id,
                name: s.name,
                descriptionRequired: s.descriptionRequired,
                remarks: s.remarks,
                defaultProjectId: s.defaultProjectId,
                isRecent: s.isRecent,
                activityCode: s.activityCode,
              };
            });
            if (this.workRegistration) {
              this.selectedActivity = this.activities.find(
                (s) => s.id === this.workRegistration.activityId
              );
              this.remarks = this.selectedActivity.remarks;
              if (this.workRegistration) {
                this.remark = this.workRegistration.activityRemark || "";
                if (this.remark && this.remarks) {
                  this.remarks.forEach((s) => {
                    if (this.remark.indexOf(s.name) > -1) {
                      this.selectedRemarks.push(s);
                    }
                  });
                }
              }
            }
          }
          this.filteredActivities = this.activities.filter((activity) => {
            return activity.activityCode[0] != "1";
          });
        })
        .catch(() => {});
    },
    onSelectActivity() {
      if (this.selectedActivity.defaultProjectId) {
        this.selectedProject = this.projects.find(
          (s) => s.id === this.selectedActivity.defaultProjectId
        );
      }
      this.remarks = this.selectedActivity.remarks;
      if (this.workRegistration) {
        this.remark = this.workRegistration.activityRemark || "";
        if (this.remark && this.remarks) {
          this.remarks.forEach((s) => {
            if (this.remark.indexOf(s.name) > -1) {
              this.selectedRemarks.push(s);
            }
          });
        }
      }
    },
    isEnabledMidnightOption() {
      let isMidnight = this.$route.query.isMidnight === true || false;
      if (isMidnight === true) return isMidnight;
      return (
        this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
        false
      );
    },
    checkIfWorkDayExists() {
      if (this.workDayId == 0) {
        this.workDayService.createWorkDay(this.workDate).then((response) => {
          this.workDayId = response.data.id;
          this.checkEmployeeType();
        });
      } else {
        this.checkEmployeeType();
      }
    },
    checkEmployeeType() {
      if (this.isWorkSlipEmployee) {
        this.saveWorkRegistration();
      } else {
        for (const wr of this.workDay.workRegistrations) {
          if (
            new Date(this.selectedStartTime).getTime() >= new Date(wr.startTime).getTime() &&
            new Date(this.selectedStartTime).getTime() < new Date(wr.endTime).getTime()
          ) {
            this.showEndTimeDialog = true;
            return;
          }
        }
        this.saveWorkRegistration();
      }
    },
    saveWorkRegistration() {
      let startTime = formatDateTimeServer(new Date(this.selectedStartTime));
      let endTime = this.isWorkSlipEmployee
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : this.showEndTimeDialog ? formatDateTimeServer(new Date(this.selectedEndTime)) : null;
      this.showEndTimeDialog = false;
      if (this.workRegistrationService.validateTimes(startTime, endTime)) {
        let remark = `${this.remark.trim()} ${this.selectedRemarks
          .map((s) => s.name)
          .join(" | ")}`;
        const model = {
          projectId: this.selectedProject ? this.selectedProject.id : null,
          activityId: this.selectedActivity.id,
          startTime: startTime,
          endTime: endTime,
          activityRemark: remark,
          isWorkSlipEmployee: this.isWorkSlipEmployee,
          deviceId: this.localStorageService.getDeviceId(),
          workDayId: +this.workDayId,
          workSlipNumber: this.selectedWorkSlip
            ? this.selectedWorkSlip.workSlipNumber
            : null,
          orderNumber: this.selectedWorkSlip
            ? this.selectedWorkSlip.orderNumber
            : null,
        };
        this.loader = this.$loading.show({});
        if (this.workRegistration) {
          model.id = +this.workRegistration.id;
          model.workDayId = this.workRegistration.workDayId;
          this.workRegistrationService
            .updateWorkRegistration(model)
            .then(() => {
              this.loader.hide();
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
            })
            .catch(() => {
              this.loader.hide();
            });
        } else {
          this.workRegistrationService
            .createWorkRegistration(model)
            .then(() => {
              this.loader.hide();
              return this.$router.push({
                name: "work-day",
                query: { workDate: formatDateServer(this.workDate) },
              });
            })
            .catch(() => {
              this.loader.hide();
            });
        }
      }
    },
    onSelectWorkSlip() {
      this.remark = "";
      if (!this.selectedWorkSlip) {
        this.filteredActivities = this.activities.filter((activity) => {
          return activity.activityCode[0] != "1";
        });
        this.selectedProject = null;
        return;
      }
      this.selectedProject = this.projects.find(
        (s) => s.id === this.selectedWorkSlip.projectId
      );
      this.selectedActivity = this.activities.find(
        (s) => s.id === this.selectedWorkSlip.activityId
      );
      //this.remark = this.selectedWorkSlip.workType;
      this.filteredActivities = this.activities.filter((activity) => {
        return activity.activityCode[0] == "1";
      });
    },
    getWorkDay() {
      const workDate = formatDateServer(this.workDate);
      this.workDayService.getWorkDay(workDate).then((res) => {
        this.workDay = res.data;
      });
    },
    onSelectedEndTime(event) {
      //this.showEndTimeDialog = false;
      this.selectedEndTime = event.value;
      this.saveWorkRegistration();
    },
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
</style>
